// extracted by mini-css-extract-plugin
export var audioPlayer = "_mq-0";